import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
} from "@material-ui/core";
import React, { ReactElement } from "react";
import { globalStyles } from "../../../assets/globalStyles";
import { useStyles } from "./anomalieStyle";
import { anomalieDetailObject } from "./anomalieTypes";
import { toUTCDateString } from "../../../utils/utils";
import { selectDate } from "../../../features/konfiguration/konfigurationSlice";
import { useAppSelector } from "../../../app/hooks";

export default function AnomalieDetaliedGrid(props: {
  anomalieDetailedObjectProp: anomalieDetailObject[];
}): ReactElement {
  const classes = {
    ...globalStyles(),
    ...useStyles(),
  };

  const isUTC = useAppSelector(selectDate);

  const anomalieDetailedObject = props.anomalieDetailedObjectProp;

  function getAnomalieTyp(anomalieTypesListe: string[]): string {
    const anomalieTypesConcatenation = anomalieTypesListe
      .slice()
      .sort()
      .map((typeElem) => `${typeElem}`)
      .join(", ")
      .toUpperCase();
    return anomalieTypesConcatenation;
  }

  return (
    <React.Fragment>
      <Grid item md={12} style={{ textAlign: "left", marginRight: "20px" }}>
        <div>
          <TableContainer component={Paper} style={{ height: "80vh" }}>
            <Table aria-label="simple table" className={classes.table}>
              <TableHead>
                <TableCell
                  className={classes.tableHeaderHorizontalLeftmostDetailed}
                >
                  Datum
                </TableCell>
                <TableCell
                  className={classes.tableHeaderHorizontalLeftmostDetailed}
                >
                  Kenngröße
                </TableCell>
                <TableCell
                  className={classes.tableHeaderHorizontalLeftmostDetailed}
                >
                  Wertung
                </TableCell>
                <TableCell
                  className={classes.tableHeaderHorizontalLeftmostDetailed}
                >
                  Anomalietyp
                </TableCell>
                <TableCell
                  className={classes.tableHeaderHorizontalLeftmostDetailed}
                >
                  Signifikanz
                </TableCell>
              </TableHead>
              <TableBody>
                {anomalieDetailedObject.map((el, index) => (
                  <TableRow key={index}>
                    <TableCell className={classes.tableCellRegular}>
                      {isUTC
                        ? toUTCDateString(new Date(el.datum))
                        : new Date(el.datum).toLocaleString()}
                    </TableCell>
                    <TableCell className={classes.tableCellRegular}>
                      {el.kenngroesse.feldname}
                    </TableCell>
                    <TableCell className={classes.tableCellRegular}>
                      {el.wert.toFixed(2)}
                    </TableCell>
                    <TableCell className={classes.tableCellRegular}>
                      {getAnomalieTyp(el.typ)}
                    </TableCell>
                    <TableCell className={classes.tableCellRegular}>
                      {el.signifikanz}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Grid>
    </React.Fragment>
  );
}
